/**
 * usePendingOperations - Manages pending copies and uploads state.
 */

import { useState, useMemo, useCallback } from 'react';
import type { PendingCopy, PendingUpload } from './types';

export function usePendingOperations() {
  const [pendingCopies, setPendingCopies] = useState<PendingCopy[]>([]);
  const [pendingUploads, setPendingUploads] = useState<PendingUpload[]>([]);

  const pendingUploadAssetIds = useMemo(
    () => new Set(pendingUploads.map((u) => u.assetId)),
    [pendingUploads]
  );

  const clearPending = useCallback(() => {
    setPendingCopies([]);
    setPendingUploads([]);
  }, []);

  return {
    pendingCopies,
    setPendingCopies,
    pendingUploads,
    setPendingUploads,
    pendingUploadAssetIds,
    clearPending,
  };
}
